// Consent-gated analytics loader. Scripts are only injected once a visitor has
// accepted the matching cookie category AND a real measurement/pixel ID is
// configured via env vars - no IDs are hardcoded here.

const GA_MEASUREMENT_ID = process.env.REACT_APP_GA_MEASUREMENT_ID;
const META_PIXEL_ID = process.env.REACT_APP_META_PIXEL_ID;

let gaLoaded = false;
let pixelLoaded = false;

const loadScript = (src) => {
  const script = document.createElement('script');
  script.src = src;
  script.async = true;
  document.head.appendChild(script);
};

const loadGoogleAnalytics = () => {
  if (gaLoaded || !GA_MEASUREMENT_ID) return;
  gaLoaded = true;

  loadScript(`https://www.googletagmanager.com/gtag/js?id=${GA_MEASUREMENT_ID}`);

  window.dataLayer = window.dataLayer || [];
  function gtag() {
    window.dataLayer.push(arguments);
  }
  window.gtag = gtag;
  gtag('js', new Date());
  gtag('config', GA_MEASUREMENT_ID, { anonymize_ip: true });
};

const loadMetaPixel = () => {
  if (pixelLoaded || !META_PIXEL_ID) return;
  pixelLoaded = true;

  /* eslint-disable */
  !(function (f, b, e, v, n, t, s) {
    if (f.fbq) return;
    n = f.fbq = function () {
      n.callMethod ? n.callMethod.apply(n, arguments) : n.queue.push(arguments);
    };
    if (!f._fbq) f._fbq = n;
    n.push = n;
    n.loaded = true;
    n.version = '2.0';
    n.queue = [];
    t = b.createElement(e);
    t.async = true;
    t.src = v;
    s = b.getElementsByTagName(e)[0];
    s.parentNode.insertBefore(t, s);
  })(window, document, 'script', 'https://connect.facebook.net/en_US/fbevents.js');
  /* eslint-enable */

  window.fbq('init', META_PIXEL_ID);
  window.fbq('track', 'PageView');
};

// Applies the visitor's saved cookie consent, loading only the scripts that
// are both consented-to and configured. Safe to call repeatedly - each
// script only loads once per page session.
export const applyConsent = (consent) => {
  if (!consent) return;
  if (consent.analytics) loadGoogleAnalytics();
  if (consent.marketing) loadMetaPixel();
};
